<template>
  <div class="custom-content-filters">
    <header-mobile-page :label="child.name" />
    <div class="header">
      Custom Content Filters
    </div>

    <custom-content-filter :mode-id="modeId"
                           :child-id="childId" />
  </div>
</template>

<script>
  import CustomContentFilter from '@/components/Child/ChildCustomFilter/CustomFilter'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      CustomContentFilter,
      HeaderMobilePage
    },

    props: {
      modeId: {
        type: String,
        required: true
      },

      childId: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      child() {
        return this.getChildById(this.childId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-content-filters {
    width: 100%;
    height: auto;

    padding: 0 20px 10px 20px;

    .header {
      color:map.get($colors, primary);
      font-size: 30px;
      text-align: center;
      margin-bottom: 20px;
    }
  }
</style>